import React, { useEffect } from 'react';
// import UilReact from '@iconscout/react-unicons/icons/uil-react'
import './App.css';
import TopButton from './components/TopButton';
// import { Input } from 'postcss';
import Inputs from './components/Inputs';
import TimeAndLocation from './components/TimeAndLocation';
import TemperatureAndDetails from './components/TemperatureAndDetails';
import Forecast from './components/Forecast';
// import getWeatherData from './services/weatherService';
import getFormattedWeatherData from './services/weatherService';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {useState} from 'react'
 
function App() {


  const [query, setQuery] = useState({q:'hyderabad'})
  const [units, setUnits] = useState('metric')
  const [weather, setWeather] = useState(null)

  useEffect(() => {
    const fetchWeather =async ()=>{
      const message = query.q ? query.q : 'current location'
      toast.info('Festing weather for ' + message)

    await getFormattedWeatherData({...query, units}).then(data => {
      toast.success(`Successfully fetched weather for ${data.name}, ${data.country}`)
      setWeather(data);
    })
    // console.log(data);
  };

  fetchWeather();
  }, [query, units])

  const formatBackground = ()=>{
    if(!weather) return ' from-cyan-700 to-blue-700'
    const threshold = units === 'metric' ? 20 : 60
    if(weather.temp <= threshold) return ' from-cyan-700 to-blue-700'

    return 'from-yellow-700 to-orange-700'
  }

  

  return (
    <div className={`mx-auto max-w-screen-lg mt-4 py-5 px-32 bg-gradient-to-br h-fit shadow-xl shadow-gray-400 ${formatBackground()}`}>
      <TopButton setQuery = {setQuery} />
      <Inputs setQuery = {setQuery} setUnits = {setUnits} units = {units}/>

      {weather && (
        <div>
          <TimeAndLocation weather={weather}/>
          <TemperatureAndDetails weather={weather}/>
          <Forecast title="hourly forecast"  items={weather.hourly}/>
          <Forecast title="daliy forecast" items={weather.daily}/>
        </div>
      )}


    <ToastContainer autoClose={5000} theme='colored' newestOnTop={true}/>

    </ div>
      );
}

export default App;
